<div class="sensor-box" *ngIf="sensorLiveData?.ts">
  <span class="sensor-box__title_line">
    {{ 'Messwerte vom' | translate }}&nbsp;<span>{{ ' ' + lastMeasurementDateTime$ }}</span>
    <div
      class="sensor-box__info"
      matTooltip="{{
        'Werte werden stündlich von Sensoren direkt am Baum gemessen und mit LoRaWAN-Technologie übertragen. PhaenoNet-User können Messgeräte unter info@phaenonet.ch ausleihen.'
          | translate
      }}"
    >
      i
    </div>
  </span>
  <div class="sensor-box__value_line">
    <span class="sensor-box__value_line--air">
      {{ 'Luft' | translate }}
    </span>
    <img class="sensor-box__icon sensor-box__value_line--air" src="assets/img/ico_temperature.png" />
    <span class="sensor-box__text sensor-box__value_line--air">{{
      sensorLiveData.at ? (sensorLiveData.at | number: '.1-1') + '°C ' : 'n/a'
    }}</span>
    <img class="sensor-box__icon sensor-box__value_line--air" src="assets/img/ico_humidity.png" />
    <span class="sensor-box__text sensor-box__value_line--air">{{
      sensorLiveData.ah ? (sensorLiveData.ah | number: '.1-1') + '% ' : 'n/a'
    }}</span>
    <span class="sensor-box__value_line--soil">
      {{ 'Boden' | translate }}
    </span>
    <img class="sensor-box__icon sensor-box__value_line--soil" src="assets/img/ico_temperature.png" />
    <span class="sensor-box__text sensor-box__value_line--soil">{{
      sensorLiveData.st ? (sensorLiveData.st | number: '.1-1') + '°C ' : 'n/a'
    }}</span>
    <img class="sensor-box__icon sensor-box__value_line--soil" src="assets/img/ico_humidity.png" />
    <span class="sensor-box__text sensor-box__value_line--soil">{{
      sensorLiveData.sh ? (sensorLiveData.sh | number: '.1-1') + '% ' : 'n/a'
    }}</span>
  </div>
</div>
